import React from 'react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

// A <th> that toggles sort on click and shows the current sort direction.
const SortableTh = ({ label, field, sortField, sortDirection, onSort, ...rest }) => (
    <th className="sortable" onClick={() => onSort(field)} {...rest}>
        {label}{' '}
        {sortField === field
            ? (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)
            : <FaSort style={{ opacity: 0.3 }} />}
    </th>
);

export default SortableTh;
